module.exports = __webpack_public_path__ + "img/icon-plus-outline.6d157290.svg";